import * as React from "react";

import { TableSkeleton } from "@/components/skeleton/TableSkeleton";

export const loadingTableHandler = (
  isLoading: boolean,
  table: React.JSX.Element
) => {
  return isLoading ? <TableSkeleton /> : table;
};
